<template>
  <div>
    <div class="yheaderWrap">
      <div class="yheader">
        <input type="text"
               v-model="domain"
               placeholder="注册域名请先查询，例如输入：300"
               @keydown.enter="query">
        <button @click="query">查询域名</button>
      </div>
    </div>
    <div class="grayBg">
      <ul class="w1200 index">
        <li>
          <a href="/">中企门户</a>&nbsp;>&nbsp;</li>
        <li>
          <a href="/domain">域名注册</a>&nbsp;>&nbsp;</li>
        <li>
          <a href="#">域名信息查询（Whois）</a>
        </li>
      </ul>
    </div>
    <div class="grayBg"
         :style="{'min-height':(isLoading||error!==false)?'800px':''}">
      <div class="w1200 infoTit">
        <h3>域名 {{$route.query.domain}} 的注册信息<img src="../static/assets/info-tit.png" /></h3>
        <div v-if="!isLoading&&error===false">
          <!-- <p>
            <label>所有者:<br />Registrant Name </label>
            <span>{{domainInfoVo.whois_registratName}}</span>
          </p>
          <p>
            <label>所有者联系邮箱:<br />Registrant E-mail</label>
            <span>{{domainInfoVo.whois_registrantEmail}}</span>
          </p> -->
          <p>
            <label>域名:<br />Domain Name</label>
            <span>{{domainInfoVo.whois_domainName}}</span>
          </p>
          <p>
            <label>注册商:<br />Sponsoring Registrar</label>
            <span>{{domainInfoVo.whois_registrar}}</span>
          </p>
          <p>
            <label>注册日期:<br />Registration Date(UTC) </label>
            <span>{{domainInfoVo.whois_registrantDate}}</span>
          </p>
          <p>
            <label>到期日期:<br />Expiration Date(UTC)</label>
            <span>{{domainInfoVo.whois_expirationDate}}</span>
          </p>
          <p>
            <label>域名状态:<br />Domain Status</label>
            <span v-html="domainInfoVo.whois_domainStatus">
            </span>
          </p>

          <p>
            <label>DNS服务器：<br />Name Server</label>
            <span v-html="domainInfoVo.whois_dnsService&&domainInfoVo.whois_dnsService"></span>
          </p>
        </div>
        <div v-if="!isLoading&&error===true">
          <div class="mt10 pl20">
            您查询的域名
            <span class="red">{{domain}}</span>
            可能未被注册，暂无域名注册信息
            <a class="reg-link"
               :href="`/domain/query-result?domainName=${domainName}&domainSuffixs=${domainSuffix}`">【尝试注册】</a>
          </div>
        </div>
        <div v-if="isLoading"
             v-loading="isLoading"> </div>
      </div>
    </div>
    <div class="grayBg pb20"
         v-if="!isLoading&&error===false">
      <div class="w1200 infoTit2 borderT10">
        <h3>详细英文注册信息如下</h3>
        <div>
          <template v-for="(item, index) in whoisInfoStr">
            <p v-if="item.indexOf('Registrant:') < 0 && item.indexOf('Registrant Contact Email:') < 0" :key="index">{{ item }}</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from './components/header'
import recommend from './components/recommend'
import cTitle from './components/title'

export default {
  data () {
    return {
      error: true,
      isLoading: false,
      domain: this.$route.query.domain,
      whoisInfoStr: '',
      domainInfoVo: { whois_dnsService: [] }
    }
  },
  components: {
    banner,
    recommend,
    cTitle
  },
  watch: {
    domain () {
      this.error = ''
    }
  },
  computed: {
    language () {
      return /[\u4e00-\u9fa5]/g.test(this.domainName) ? 'zh-CN' : 'en'
    },
    domainName () {
      return this.domain.substr(0, this.domain.indexOf('.'))
    },
    domainSuffix () {
      return this.domain.substr(this.domain.indexOf('.'), this.domain.length)
    }
  },
  methods: {
    query () {
      // window.location.hash.split('domain=')[1] = this.domain
      this.$router.push({ query: { domain: this.domain.toLowerCase() } })
      // console.log(this.$route.query.domain)
      this.whoisInfoStr = ''
      this.domainInfoVo = { whois_dnsService: [] }
      const reg = new RegExp(
        '^[A-Za-z０１２３４５６７８９－0-9-Ａ-Ｚａ-ｚ\u4e00-\u9fa5]+$'
      )
      if (!this.domain) {
        this.$msgbox({
          type: 'error',
          message: '请填写一个域名'
        })
        return
      }
      if (!this.domainName) {
        this.$msgbox({
          type: 'error',
          message: '请填写一个域名后缀'
        })
        return
      }

      if (!reg.test(this.domainName) || this.domainName.length > 63) {
        if (this.language === 'zh-CN') {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            // type: 'error',
            message:
              '提示：中文域名至少需要含有一个中文文字，可以包含中文、字母a-z(大小写等价)、数字0-9或者半角的连接符“-”，“-”不能放在开头或者结尾，输入内容不能超过63个字符，最多可以注册19个汉字。'
          })
        } else {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            // type: 'error',
            message:
              '提示：域名可由英文字母（a-z,不区分大小写）、数字（0-9）、连字符“-”（即中横线）,不能使用空格及特殊字符（如！、$、&、？等），“-”不能单独填写或连续使用，不能放在开头或结尾，输入内容不能超过63个字符。'
          })
        }

        return
      }

      this.isLoading = true

      $.get(`/domain/whois?domain=${this.domain.toLowerCase()}`).then(response => {
        this.isLoading = false

        if (response && response.status === 102) {
          this.error = true
          return
        }

        if (response && response.domainInfoVo && response.domainInfoVo.error != null) {
          this.error = true
          return
        }

        this.error = false

        this.domainInfoVo = response.domainInfoVo
        this.whoisInfoStr = response.domainInfoVo.whoisInfoStr.replace(
          /\n/g,
          '</br>'
        ).split('</br>')
      })
    }
  },
  created () {
    // this.domainName = this.$route.query.domainName
    // this.domainSuffix = this.$route.query.domainSuffix
    this.query()
  }
}
</script>

<style  lang="scss">
@import "../static/css/info.scss";
</style>



// WEBPACK FOOTER //
// src/info.vue